module.exports = __webpack_public_path__ + "static/media/homa1.6040b01a.png";